import { makeStyles } from '@material-ui/styles';

export const useAppSelectCustomStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
    display: (props) => (props.hidden ? 'none' : ''),
  },
  container: {
    padding: (props) => (props.notPaddingContainer ? '0px' : ''),
  },
  errorText: {
    color: '#FF0000',
    textAlign: 'center',
  },
}));
